export default "__VITE_ASSET__5be340e2__"